import React from 'react';
import { EyeIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
interface PreviewNoteProps {
  className?: string;
}
export function PreviewNote({
  className
}: PreviewNoteProps) {
  return <p role="note" className={twMerge('flex items-start gap-3 border-l-[3px] border-brand bg-paper-deep px-4 py-3 text-[15px] leading-snug text-ink', className)} data-id="element-268" data-mp="s7v12clpbpui">
      <EyeIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-deep" data-id="element-269" data-mp="1kwii1vzf3t29" />
      <span data-id="element-270" data-mp="1putri5lsw1jy">
        <strong className="font-semibold" data-id="element-271" data-mp="1pt8um9c0k6ix">Client preview</strong> — this form does not send requests.
      </span>
    </p>;
}